<template>
  <div class="login-container">
    <div v-if="!isDirectLogin" class="login-content">
      <div class="logo-wrapper">
        <img src="@/assets/lek/lenx-logo-footer-dark.svg" alt="LENX" class="logo" />
      </div>

      <div class="login-card">
        <h3 class="title">{{ $t('login_txt') || '欢迎登录' }}</h3>

        <form class="login-form">
          <div class="input-group">
            <div class="input-label">管理员账号</div>
            <cube-input
              v-model="loginObj.admin"
              :type="type"
              placeholder="请输入管理员用户名"
              :maxlength="20"
              :clearable="clearable"
              :autocomplete="true"
              class="custom-input"
            />
          </div>

          <div class="input-group">
            <div class="input-label">管理员密码</div>
            <cube-input
              v-model="loginObj.password"
              type="password"
              placeholder="请输入管理员密码"
              :maxlength="20"
              :clearable="clearable"
              :autocomplete="true"
              class="custom-input"
            />
          </div>

          <div class="input-group">
            <div class="input-label">员工ID</div>
            <cube-input
              v-model="loginObj.userId"
              :type="type"
              :placeholder="$t('input_uid')"
              :maxlength="20"
              :clearable="false"
              :autocomplete="true"
              :eye="eyeObj"
              readonly
              class="custom-input readonly-input"
              @blur="blurPwd"
            />
            <p
              class="cube-validator-msg-def"
              :class="{hidden: !loginObj.userIdTips}"
            >
              {{ loginObj.userIdTips }}
            </p>
          </div>
        </form>

        <div class="prompt">当前版本为内部测试版本<br />请使用您的员工ID登录</div>

        <button
          type="button"
          class="login-btn"
          :class="{disable: isloging}"
          :disabled="isloging"
          @click="adminLogin()"
        >
          <van-loading v-if="isloging" class="login-spinner" color="#fff" size="20px" />
          <span>{{ isloging ? '登录中...' : $t('login_btn') }}</span>
        </button>
      </div>

      <div class="version-info">{{ releaseInfoText }}</div>

      <van-popup
        v-model="showRoleSelectPopup"
        class="role-select-popup-container"
        :close-on-click-overlay="false"
        round
      >
        <div class="role-select-box">
          <div class="role-header">请选择登录身份</div>
          <div class="role-list">
            <div
              v-for="(role, index) in rolePopupList"
              :key="index"
              class="role-option"
              @click="onSelectRole(role)"
            >
              <span class="role-name">{{ role.role_name }}</span>
              <van-icon name="arrow" color="#999" />
            </div>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>
<script>
import loginMixins from '@/mixins/loginMixins';
import { Popup, Icon, Loading } from 'vant';
import { removeLocalStorage } from '@/utils/index';

export default {
  components: {
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [Loading.name]: Loading
  },
  mixins: [loginMixins],
  computed: {
    releaseInfoText() {
      const version = process.env.VUE_APP_DISPLAY_VERSION || '';
      const buildTime = process.env.VUE_APP_BUILD_TIME || '';
      const commitTime = process.env.VUE_APP_GIT_COMMIT_TIME || '';

      if (version && commitTime) {
        return `v${version} | ${commitTime}`;
      }

      if (version) {
        return `v${version}`;
      }

      return buildTime || '';
    }
  },
  created() {
    removeLocalStorage('open_id');
    removeLocalStorage('token');
    removeLocalStorage('union_id');
    this.loginObj.userId = '504735';
  }
};
</script>
<style lang="scss" scoped>
@import '@/styles/var.scss';

.login-container {
  height: 100%;
  min-height: 100vh;
  width: 100%;
  position: relative;
  isolation: isolate;
  background:
    linear-gradient(118deg, rgba(255, 255, 255, 0) 0 22%, rgba(255, 255, 255, 0.08) 22% 36%, rgba(255, 255, 255, 0) 36% 100%),
    linear-gradient(124deg, rgba(255, 255, 255, 0) 0 62%, rgba(0, 184, 82, 0.18) 62% 73%, rgba(255, 255, 255, 0) 73% 100%),
    radial-gradient(circle at 78% 18%, rgba(184, 222, 0, 0.14), transparent 30%),
    linear-gradient(180deg, #064527 0%, #003d25 48%, #031b13 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
}

.login-container::before,
.login-container::after {
  content: '';
  position: fixed;
  inset: 0;
  z-index: -1;
  pointer-events: none;
}

.login-container::before {
  background:
    linear-gradient(122deg, transparent 0 12%, rgba(18, 83, 53, 0.78) 12% 28%, transparent 28% 100%),
    linear-gradient(122deg, transparent 0 56%, rgba(10, 58, 38, 0.8) 56% 72%, transparent 72% 100%);
}

.login-container::after {
  background: linear-gradient(180deg, rgba(3, 27, 19, 0) 0%, rgba(3, 27, 19, 0.72) 100%);
}

.login-content {
  width: 100%;
  padding: 20px 0 32px;
  box-sizing: border-box;
}

.logo-wrapper {
  display: flex;
  justify-content: center;
  margin-bottom: 40px;

  .logo {
    height: 42px;
    width: auto;
    object-fit: contain;
  }
}

.login-card {
  background: rgba(255, 255, 255, 0.97);
  border-radius: 16px;
  box-shadow: 0 18px 45px rgba(0, 24, 14, 0.26);
  padding: 32px 24px;
  margin: 0 20px 24px;

  .title {
    font-size: 22px;
    color: #333;
    margin: 0 0 24px 0;
    text-align: center;
    font-weight: 600;
  }

  .login-form {
    .input-group {
      margin-bottom: 16px;

      .input-label {
        font-size: 13px;
        color: #666;
        margin-bottom: 6px;
        font-weight: 500;
        margin-left: 4px;
      }

      .custom-input {
        &::after {
          display: none; // Remove 1px bottom border from cube-ui if present
        }
        background: #ffffff;
        border-radius: 8px;
        padding: 2px 4px;
        border: 1px solid #ebedf0;

        &:focus-within {
          background: #fff;
          border-color: #00b852;
        }

        &.readonly-input {
          background: #f7f8fa;
          border-color: transparent;
          color: #969799;
        }
      }

      .cube-validator-msg-def {
        min-height: 12px;
        font-size: 12px;
        color: #e64340;
        text-align: left;
        margin-top: 5px;
        padding-left: 4px;
        &.hidden {
          visibility: hidden;
        }
      }
    }
  }

  .prompt {
    font-size: 12px;
    line-height: 1.6;
    color: #999;
    text-align: center;
    margin: 8px 0 24px 0;
  }

  .login-btn {
    border: 0;
    min-height: 48px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background: linear-gradient(90deg, #00b852 0%, #b8de00 100%);
    color: #ffffff;
    box-sizing: border-box;
    font-weight: 500;
    padding: 14px 20px;
    font-size: 16px;
    border-radius: 25px; // Fully rounded
    box-shadow: 0 8px 18px rgba(0, 184, 82, 0.24);
    transition: all 0.2s;
    user-select: none;

    &:active {
      transform: scale(0.98);
      box-shadow: 0 4px 10px rgba(0, 184, 82, 0.22);
    }

    &.disable {
      background: #a8a8a8;
      box-shadow: none;
      cursor: not-allowed;
      opacity: 1;
    }

    .login-spinner {
      margin-right: 8px;
    }
  }
}

.version-info {
  color: rgba(255, 255, 255, 0.55);
  font-size: 12px;
  line-height: 1.5;
  text-align: center;
}

.role-select-popup-container {
  width: 80%;
  max-width: 320px;
  border-radius: 16px;
  overflow: hidden;
}
.role-select-box {
  background: white;
  padding: 0;
}
.role-header {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  padding: 24px 0 16px;
  color: #333;
}
.role-list {
  padding: 0 20px 24px;
}
.role-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8f9fa;
  padding: 16px 20px;
  margin-bottom: 12px;
  border-radius: 12px;
  font-size: 16px;
  color: #333;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid transparent;
}
.role-option:active {
  background: #eef1f6;
  border-color: #dcdfe6;
  transform: scale(0.98);
}
.role-name {
  flex: 1;
}
</style>
